import React, { useState } from 'react';

const BoatCreationForm = ({ onCreateBoat, users }) => {
  const [newBoat, setNewBoat] = useState({
    name: '',
    userId: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newBoat.name && newBoat.userId) {
      onCreateBoat(parseInt(newBoat.userId), { name: newBoat.name, scans: [] });
      setNewBoat({ name: '', userId: '' });
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Agregar Nueva Embarcación</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de la Embarcación</label>
          <input
            type="text"
            value={newBoat.name}
            onChange={(e) => setNewBoat({...newBoat, name: e.target.value})}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Asignar a Usuario</label>
          <select
            value={newBoat.userId}
            onChange={(e) => setNewBoat({...newBoat, userId: e.target.value})}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            required
          >
            <option value="">Seleccionar usuario</option>
            {users.filter(user => user.role === 'user').map(user => (
              <option key={user.id} value={user.id}>{user.username}</option>
            ))}
          </select>
        </div>
        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 transition-colors"
        >
          Agregar Embarcación
        </button>
      </form>
    </div>
  );
};

export default BoatCreationForm;